export enum DiceMessageType {
  Guess = 'guess',
  Dice = 'dice',
  Challenge = 'challenge'
}

export interface DiceMessage {
  user: string;
  dice: number[];
  guess?: any;
  exacto?: boolean;
  type: DiceMessageType;
}
